import { all, call, CallEffect, fork, put, PutEffect, takeEvery } from "redux-saga/effects";
import { fetchRecentNewsSuccess, fetchAutomationStatisticsSuccess } from "../actions/Dashboard";
import { ActionTypes } from "../../constants/ActionTypes";
import { fetchError } from "../actions/Common";
import { ShowError } from "../../helper/Alert";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

// recent news
const getRecentNews = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get("dashboard/getRecentNews");
}

function* fetchRecentNewsRequest(): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedRecentNews = yield call(getRecentNews);
        yield put(fetchRecentNewsSuccess(fetchedRecentNews.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchRecentNews() {
    yield takeEvery(ActionTypes.GET_RECENT_NEWS, fetchRecentNewsRequest);
}

// automation statistics
const getAutomationStatistics = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get("dashboard/getAutomationStatistics");
}

function* fetchAutomationStatisticsRequest(): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedAutomationStatistics = yield call(getAutomationStatistics);
        yield put(fetchAutomationStatisticsSuccess(fetchedAutomationStatistics.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchAutomationStatistics() {
    yield takeEvery(ActionTypes.GET_AUTOMATION_STATISTICS, fetchAutomationStatisticsRequest);
}

export default function* rootSaga() {
    yield all([fork(fetchRecentNews), fork(fetchAutomationStatistics)]);
}
